import React, { useState } from "react";
import { FiFilter, FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import DateRange from "../../shared/DateRange";
import Checkbox from "../../shared/Checkbox";
const filterItems = ["Role", "Team", "Email", "Member", "Recommendation"];

const PageHeaderDate = ({onApplyDateRange}) => {
  const [toggleDateRange, setToggleDateRange] = useState(false);
  const [leadData, setLeadsData] = useState({});

  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        <div
          className="position-relative date-picker-field"
          onClick={() => setToggleDateRange(!toggleDateRange)}
        >
          <DateRange
            toggleDateRange={toggleDateRange}
            setToggleDateRange={setToggleDateRange}
            onApply={onApplyDateRange}
          />
        </div>
      
      </div>
    </>
  );
};

export default PageHeaderDate;
